import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { ButtonModule, CommonWordingModule } from '@platform-frontend/ui-tools';
import { RouterExtensionsModule } from '@platform-frontend/util';
import { CommercialCommonModule } from '../commercial-common/commercial-common.module';
import { OverviewComponent } from './overview/overview.component';

@NgModule({
  declarations: [OverviewComponent],
  imports: [
    ButtonModule,
    CommonModule,
    CommonWordingModule,
    CommercialCommonModule,
    ReactiveFormsModule,
    RouterExtensionsModule,
    RouterModule,
    TranslocoModule
  ],
  exports: [OverviewComponent]
})
export class PurchaseInformationModule {}
